import {trans} from "../../../translations/translations";

export const question1Helper = [
    {id: 1, text: trans('question1.helper.hunger', 'sos'), order: 1, status: 'no-selected'},
    {id: 2, text: trans('question1.helper.desire', 'sos'), order: 2, status: 'no-selected'},
]
